var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center main"},[_c('h1',{staticClass:"mt-10 mb-5"},[_vm._v("Vítejte v administraci Bzuco Inspector")]),(!_vm.loggedUser)?_c('v-btn',{attrs:{"to":{name:'login'}}},[_vm._v("Přihlásit")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }